import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-200541e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }

import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { NavBar, Cell } from "vant";

export default /*#__PURE__*/_defineComponent({
  name: 'AboutUs',
  setup(__props) {

const router = useRouter();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "关于我们",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Cell), {
        "is-link": "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('ServiceAgreement')))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
          }, "服务协议 ", 4)
        ]),
        _: 1
      }),
      _createVNode(_unref(Cell), {
        "is-link": "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('PrivacyAgreement')))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
          }, "隐私政策 ", 4)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})